function getPlacement (modifiers) {
  if (modifiers.right) return 'right'
  if (modifiers.bottom || modifiers.down) return 'bottom'
  if (modifiers.left) return 'left'
  return 'top'
}

function getOppositePlacement (placement) {
  const oppositePlacement = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
  }

  return oppositePlacement[placement] || 'top'
}

function calculatePosition (rect, tooltipRect, placement, gap) {
  switch (placement) {
    case 'top':
      return {
        top: rect.top - tooltipRect.height - gap,
        left: rect.left + (rect.width - tooltipRect.width) / 2
      }
    case 'bottom':
      return {
        top: rect.bottom + gap,
        left: rect.left + (rect.width - tooltipRect.width) / 2
      }
    case 'left':
      return {
        top: rect.top + (rect.height - tooltipRect.height) / 2,
        left: rect.left - tooltipRect.width - gap
      }
    case 'right':
    default:
      return {
        top: rect.top + (rect.height - tooltipRect.height) / 2,
        left: rect.right + gap
      }
  }
}

function overflowsViewport (position, tooltipRect, padding) {
  const viewportWidth = window.innerWidth
  const viewportHeight = window.innerHeight

  return (
    position.left < padding ||
    position.left + tooltipRect.width > viewportWidth - padding ||
    position.top < padding ||
    position.top + tooltipRect.height > viewportHeight - padding
  )
}

function clampPosition (position, tooltipRect, padding) {
  const viewportWidth = window.innerWidth
  const viewportHeight = window.innerHeight

  return {
    top: Math.min(
      Math.max(position.top, padding),
      Math.max(padding, viewportHeight - tooltipRect.height - padding)
    ),
    left: Math.min(
      Math.max(position.left, padding),
      Math.max(padding, viewportWidth - tooltipRect.width - padding)
    )
  }
}

function positionTooltip (el, tooltipEl, preferredPlacement) {
  if (!el || !tooltipEl) return preferredPlacement
  const rect = el.getBoundingClientRect()

  tooltipEl.style.top = '0px'
  tooltipEl.style.left = '0px'
  const tooltipRect = tooltipEl.getBoundingClientRect()
  const gap = 6
  const padding = 8

  let finalPlacement = preferredPlacement
  let position = calculatePosition(rect, tooltipRect, finalPlacement, gap)

  if (overflowsViewport(position, tooltipRect, padding)) {
    const fallbackPlacement = getOppositePlacement(preferredPlacement)
    const fallbackPosition = calculatePosition(rect, tooltipRect, fallbackPlacement, gap)

    if (!overflowsViewport(fallbackPosition, tooltipRect, padding)) {
      finalPlacement = fallbackPlacement
      position = fallbackPosition
    } else {
      position = fallbackPosition
      finalPlacement = fallbackPlacement
    }
  }

  const clampedPosition = clampPosition(position, tooltipRect, padding)

  tooltipEl.className = `tooltip ${finalPlacement} in`
  tooltipEl.style.top = clampedPosition.top + 'px'
  tooltipEl.style.left = clampedPosition.left + 'px'

  return finalPlacement
}

function createTooltipEl (text, placement) {
  const wrapper = document.createElement('div')
  wrapper.className = `tooltip ${placement} in`
  wrapper.setAttribute('role', 'tooltip')
  wrapper.style.position = 'fixed'
  wrapper.style.zIndex = '2147483647'
  wrapper.style.pointerEvents = 'none'
  wrapper.style.isolation = 'isolate'
  wrapper.style.contain = 'layout paint style'
  wrapper.style.transform = 'translateZ(0)'

  const arrow = document.createElement('div')
  arrow.className = 'tooltip-arrow'
  wrapper.appendChild(arrow)

  const inner = document.createElement('div')
  inner.className = 'tooltip-inner'
  inner.textContent = text
  wrapper.appendChild(inner)

  return wrapper
}

function show (el) {
  if (!el) return
  hide(el)
  const text = el._pttTooltipText
  if (!text) return

  const placement = el._pttTooltipPlacement || 'top'
  const tooltipEl = createTooltipEl(text, placement)
  document.body.appendChild(tooltipEl)
  el._pttTooltipEl = tooltipEl

  el._pttTooltipActivePlacement = positionTooltip(el, tooltipEl, placement)
}

function hide (el) {
  if (!el) return
  if (el._pttTooltipEl) {
    el._pttTooltipEl.remove()
    el._pttTooltipEl = null
  }
}

function setup (el, binding) {
  if (!el) return
  if (el._pttTooltipBound) return
  el._pttTooltipBound = true

  el._pttTooltipPlacement = getPlacement(binding.modifiers)
  el._pttTooltipText = binding.value

  el._pttTooltipShowHandler = () => show(el)
  el._pttTooltipHideHandler = () => hide(el)

  el.addEventListener('mouseenter', el._pttTooltipShowHandler)
  el.addEventListener('mouseleave', el._pttTooltipHideHandler)
  el.addEventListener('focus', el._pttTooltipShowHandler)
  el.addEventListener('blur', el._pttTooltipHideHandler)
}

function teardown (el) {
  if (!el) return
  hide(el)
  el._pttTooltipBound = false
  el.removeEventListener('mouseenter', el._pttTooltipShowHandler)
  el.removeEventListener('mouseleave', el._pttTooltipHideHandler)
  el.removeEventListener('focus', el._pttTooltipShowHandler)
  el.removeEventListener('blur', el._pttTooltipHideHandler)
}

function onUpdate (el, binding) {
  if (!el) return
  el._pttTooltipText = binding.value
  el._pttTooltipPlacement = getPlacement(binding.modifiers)
  if (el._pttTooltipEl) {
    el._pttTooltipEl.querySelector('.tooltip-inner').textContent = binding.value || ''
    el._pttTooltipActivePlacement = positionTooltip(el, el._pttTooltipEl, el._pttTooltipPlacement)
  }
}

export const tooltip = {
  mounted: setup,
  updated: onUpdate,
  unmounted: teardown
}
